import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { scenarioShowHurdleStore } from '../../storage/local/index';
import { CreateScenarioInvestment } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const usePatchScenarioInvestment = () => {
  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: updateScenarioInvestment, isPending } = useAppMutation(
    [QueryKey.PATCH_SCENARIO_INVESTMENT],
    {
      mutationFn: ({
        data,
        scenarioId,
        investmentId,
      }: {
        data: CreateScenarioInvestment;
        investmentId: string;
        scenarioId: string;
      }) =>
        ApiService.patch(
          {
            endpoint: BackendRoute.SCENARIOS,
            routePath: [scenarioId, 'investments', investmentId],
          },
          {
            body: data,
          },
        ),
      onSuccess: () => {
        scenarioShowHurdleStore.delete();
        invalidateCalculationQueries();
      },
    },
  );
  return { updateScenarioInvestment, isPending };
};
